import { useState } from "react";

import useWorkspaces from "common/datahooks/useWorkspaces";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AgencySubscriptionCard from "../../AgencySubscriptionCard";
import AgencyLicenseSummary from "./AgencyLicenseSummary";
import DesktopTable from "./DesktopTable";
import MobileList from "./MobileLayout/MobileList";

interface PlanDetailsProps {
  onManageSubscription?: () => void;
}

export default function PlanDetails({
  onManageSubscription,
}: PlanDetailsProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { workspaces } = useWorkspaces();

  const [editingWorkspaceId, setEditingWorkspaceId] = useState<string>();

  const filteredWorkspaces = workspaces
    ? workspaces.filter(({ role }) => role === "owner")
    : [];

  const Component = isDesktop ? DesktopTable : MobileList;

  return (
    <>
      <AgencySubscriptionCard
        isAgencyPage
        onManageSubscription={onManageSubscription}
      />
      <AgencyLicenseSummary isCompact={false} />
      <Component
        workspaces={filteredWorkspaces}
        editingWorkspaceId={editingWorkspaceId}
        setEditingWorkspaceId={setEditingWorkspaceId}
      />
    </>
  );
}
